export default {
  name: 'users/details',
}
